import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { convertNumbers } from "../../utils/ConvertNumbers";
import moment from "jalali-moment";
import InfoIcon from "@material-ui/icons/Info";
import {
  BLACK,
  BLUE_COLOR,
  DARK_SIDEBAR,
  ERROR_COLOR,
  GREEN_PRIMRY,
  ORANGE_COLOR,
  SILVER_TABLE_COLOR,
  WHITE,
} from "../../utils/const";
import { styled } from "@material-ui/core/styles";
import { useHistory } from "react-router";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: SILVER_TABLE_COLOR,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const TableRecord = (props) => {
  const history = useHistory();

  const goToProjectDetails = () => {
    history.push("/admin/project-dash/" + props.project.id);
  };

  return (
    <StyledTableRow>
      <TableCell component="th" scope="row">
        {convertNumbers(
          props.idx + 1 + props.pageSize * (props.pageNumber - 1)
        )}
      </TableCell>
      <TableCell align="center">{convertNumbers(props.project.name)}</TableCell>
      <TableCell align="center">
        {convertNumbers(props.project.location)}
      </TableCell>
      <TableCell align="center">
        {convertNumbers(props.project.counters)}
      </TableCell>
      <TableCell align="center">
        {convertNumbers(
          moment(props.project.date).locale("fa").format("YYYY/MM/DD")
        )}
      </TableCell>
      <TableCell align="center">
        <InfoIcon
          onClick={goToProjectDetails}
          style={{
            color: BLUE_COLOR,
            cursor: "pointer",
            fontSize: "24px",
          }}
        />
      </TableCell>
    </StyledTableRow>
  );
};

export default TableRecord;
